import { render } from "./forclosure-7.vue?vue&type=template&id=4284b47c&scoped=true"
import script from "./forclosure-7.vue?vue&type=script&lang=js"
export * from "./forclosure-7.vue?vue&type=script&lang=js"

import "./forclosure-7.vue?vue&type=style&index=0&id=4284b47c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4284b47c"]])

export default __exports__